export class CampaignStatsData {
  name: string;
  data: Record<string, number>;

  constructor(values: Partial<CampaignStatsData> = {}) {
    this.name = values.name;
    this.data = values.data;
  }
}
